import { z } from 'zod';

export const calculateFestivalCo2DtoSchema = z.object({
  unit: z.string(),
  completion: z.number(),
  score: z.number(),
  sectors: z.object({
    artists: z.object({
      completion: z.number(),
      score: z.number(),
      categories: z.object({
        mobility: z.object({ score: z.number() }),
        catering: z.object({ score: z.number() }),
        accommodation: z.object({ score: z.number() }),
        cargo: z.object({ score: z.number() }),
      }),
    }),
    team: z.object({
      completion: z.number(),
      score: z.number(),
      categories: z.object({
        mobility: z.object({ score: z.number() }),
        catering: z.object({ score: z.number() }),
        accommodation: z.object({ score: z.number() }),
      }),
    }),
    public: z.object({
      completion: z.number(),
      score: z.number(),
      categories: z.object({
        mobility: z.object({ score: z.number() }),
        catering: z.object({ score: z.number() }),
        accommodation: z.object({ score: z.number() }),
        digital: z.object({ score: z.number() }),
      }),
    }),
    site: z.object({
      completion: z.number(),
      score: z.number(),
      categories: z.object({
        energy: z.object({ score: z.number() }),
        water: z.object({ score: z.number() }),
        equipment: z.object({ score: z.number() }),
        waste: z.object({ score: z.number() }),
        cargo: z.object({ score: z.number() }),
        building: z.object({ score: z.number() }),
      }),
    }),
  }),
});
